import request from '@/utils/request';
import { $t } from '@/i18n'

// 店铺策略列表
export function shopStrategyList(params) {
  return request({
    url: `/mct_shop_strategy/v1`,
    params,
  });
}

// 批量变更
export function apiBatchChange(data) {
  return request({
    url: `/mct_shop_strategy/v1`,
    method: 'PUT',
    data,
  });
}

// 批量删除
export function apiBatchesDelete(data) {
  return request(
    {
      url: `/mct_shop_strategy/v1`,
      method: 'DELETE',
      data,
    },
    {
      success: true,
      successMsg: $t('constant.deletedSuccessfully'),
    }
  );
}

// 策略详情
export function apiPolicyDetails(id) {
  return request({
    url: `/mct_shop_strategy/${id}/v1`,
  });
}

// 选择店铺
export function apiSelectShop(data) {
  return request({
    url: `/mct_shop_strategy/shop/v1`,
    method: 'POST',
    data,
  });
}

// 新增店铺策略
export function apiAddPolicy(data) {
  return request(
    {
      url: `/mct_shop_strategy/v1`,
      method: 'POST',
      data,
    },
    {
      success: true,
      successMsg: $t('constant.addSuccess'),
    }
  );
}

// 根据策略回显店铺
export function apiStrategyShop(id) {
  return request({
    url: `/mct_shop_strategy/${id}/shop`,
    method: 'GET',
  });
}

// 价格策略列表
export function priceStrategyList(params) {
  return request({
    url: `/mct_strategy/v1`,
    params,
  });
}

// 价格策略禁用
export function apiPriceDisabled(id, data) {
  return request(
    {
      url: `/mct_strategy/disabled/${id}/v1`,
      method: 'PUT',
      data,
    },
    {
      success: true,
      successMsg: $t('common.operatorOK'),
    }
  );
}

// 价格策略删除
export function apiPriceStrategyDelete(id) {
  return request(
    {
      url: `/mct_strategy/${id}/v1`,
      method: 'DELETE',
    },
    {
      success: true,
      successMsg: $t('constant.deletedSuccessfully'),
    }
  );
}

// 价格策略详情
export function policyDetails(id) {
  return request({
    url: `/mct_strategy/${id}/v1`,
  });
}

// 价格策略编辑
export function apiEditPriceStrategy(id, data) {
  return request({
    url: `/mct_strategy/${id}/v1`,
    method: 'PUT',
    data,
  });
}

// 价格策略新增
export function addPriceStrategy(data) {
  return request({
    url: `/mct_strategy/v1`,
    method: 'POST',
    data,
  });
}

// 价格策略查询组织信息
export function apiSelectPriceStrategyOrg(id) {
  return request({
    url: `/mct_strategy/org/${id}/v1`,
    method: 'GET',
  });
}

// 价格策略查询店铺信息
export function apiSelectPriceStrategyShop(id) {
  return request({
    url: `/mct_strategy/select/shop/${id}/v1`,
    method: 'GET',
  });
}
